import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
import PaginationCompAdminPayment from "./PaginationCompAdminPayment";
const AdminPayment = ({ history }) => {
  const styles = {
    backgroundColor: `rgb(228, 6, 19)`,
    color: "white",
  };
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState([]);
  const [info, setInfo] = useState({
    paymentStatus: "",
    startDate: "",
    endDate: "",
    joinerName: "",
    brief: "",
    size: 10,
  });
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageMaxNo: 0,
  });
  const [checkedList, setCheckedList] = useState([]);
  const [updateDOM, setUpdateDOM] = useState({
    status: "",
    deposit: "",
  });
  const [flag, setFlag] = useState(false);
  const updateStatus = async () => {
    console.log("### updateStatus ### ", updateDOM, checkedList);
    console.log("### stringfy ### ", checkedList.toString());
    if (updateDOM.status == null || updateDOM.status == "") {
      alert("결제상태를 지정해주세요.");
      return;
    }
    if (checkedList.length == 0) {
      alert("체크박스를 적어도 한개 이상 체크해야됩니다.");
      return;
    }

    try {
      let accessToken = getBearerString();
      let headers = {
        headers: {
          Authorization: accessToken,
        },
      };
      let response = await axios.post(
        `${root_url}/api/admin/reception/confirm/${updateDOM.status}`,
        {
          deposit: updateDOM.deposit,
          joinSeqs: checkedList.toString(),
        },
        headers
      );
      console.log(response.data);
      fetchData(info);
      alert("처리되었습니다.");
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
    }
  };
  const fetchDataURL = async () => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    const params = window.location.toString().split("?")[1];
    const pageNo = params.split("&")[0].split("=")[1];
    try {
      let response = await axios.get(
        `${root_url}/api/admin/reception/paid?${params}`,
        headers
      );
      console.log("## response.data ##", response.data);
      setPageInfo({ pageNo: pageNo, pageMaxNo: response.data.pageMaxNo });
      setResult(response.data.applications);
      history.push(`/admin/reception/payment?${params}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }

    setIsLoading(false);
  };
  const fetchData = async (obj) => {
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    let postDOM = {};
    let params = "";
    if (pageInfo.pageNo != null && pageInfo.pageNo != "") {
      postDOM.pageNo = pageInfo.pageNo;
      params += "pageNo=" + 1 + "&";
    }
    if (obj.size != null && obj.size != "") {
      postDOM.size = obj.size;
      params += "rowCount=" + obj.size + "&";
    }
    if (obj.paymentStatus != null && obj.paymentStatus != "") {
      postDOM.paymentStatus = obj.paymentStatus;
      params += "paymentStatus=" + obj.paymentStatus + "&";
    }
    if (obj.startDate != null && obj.startDate != "") {
      postDOM.startDate = obj.startDate;
      params += "startDate=" + obj.startDate + "&";
    }
    if (obj.endDate != null && obj.endDate != "") {
      postDOM.endDate = obj.endDate;
      params += "endDate=" + obj.endDate + "&";
    }
    if (obj.joinerName != null && obj.joinerName != "") {
      postDOM.joinerName = obj.joinerName;
      params += "joinerName=" + obj.joinerName + "&";
    }
    if (obj.brief != null && obj.brief != "") {
      postDOM.brief = obj.brief;
      params += "brief=" + obj.brief + "&";
    }
    // const url = window.location.toString();
    // params = url.split("?")[1];
    console.log(params);
    try {
      let response = await axios.get(
        `${root_url}/api/admin/reception/paid?${params}`,
        headers
      );
      console.log("## response.data ##", response.data);
      setPageInfo({ pageNo: 1, pageMaxNo: response.data.pageMaxNo });
      setResult(response.data.applications);
      history.push(`/admin/reception/payment?${params}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert("권한이 존재하지 않습니다.");
        localStorage.setItem("accessToken", "");
        window.location.href = "/admin/login";
      }
      if (e.response === undefined) {
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }

    setIsLoading(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("#### info ####", info);
    fetchData(info);
  };

  useEffect(() => {
    fetchDataURL();
  }, [window.location.toString()]);

  useEffect(() => {
    if (checkedList.length >= 2) {
      setFlag(true);
      setUpdateDOM({ ...updateDOM, deposit: "" });
    } else {
      setFlag(false);
    }
  }, [checkedList]);

  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        결제확인
      </h1>
      <Form inline onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let paymentStatus = e.target.value;
                setInfo({ ...info, paymentStatus: paymentStatus });
              }}
            >
              <option value="">결제상태</option>
              <option value="RSVT">입금대기</option>
              <option value="CMPL">입금완료</option>
              <option value="CNCL">참가취소</option>
            </Form.Control>
          </Col>
          <Col>
            <Form.Group style={{ display: "flex" }}>
              <Form.Control
                type="date"
                id=""
                onChange={(e) => {
                  let startDate = e.target.value;
                  setInfo({ ...info, startDate: startDate });
                }}
              />
              <Form.Label className="ms-2 me-2">~</Form.Label>
              <Form.Control
                type="date"
                id=""
                min={info.startDate}
                onChange={(e) => {
                  let endDate = e.target.value;
                  setInfo({ ...info, endDate: endDate });
                }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Control
              type="input"
              id=""
              placeholder="신청자명"
              onChange={(e) => {
                let joinerName = e.target.value;
                console.log(joinerName);
                setInfo({ ...info, joinerName: joinerName });
              }}
            />
          </Col>
          <Col>
            <Form.Control
              type="input"
              id=""
              placeholder="입금자명"
              onChange={(e) => {
                let brief = e.target.value;
                setInfo({ ...info, brief: brief });
              }}
            />
          </Col>
          <Col>
            <Button className="me-4" type="submit">
              검색
            </Button>
          </Col>
        </Row>
      </Form>
      <Form>
        <Row>
          <Col>
            <Form.Control
              type="number"
              id=""
              placeholder="입금 금액"
              disabled={flag}
              value={updateDOM.deposit}
              onChange={(e) => {
                let deposit = e.target.value;
                setUpdateDOM({ ...updateDOM, deposit: deposit });
              }}
            />
          </Col>
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let status = e.target.value;
                setUpdateDOM({ ...updateDOM, status: status });
              }}
            >
              <option value="">결제상태</option>
              <option value="RSVT">입금대기</option>
              <option value="CMPL">입금완료</option>
              <option value="CNCL">참가취소</option>
            </Form.Control>
          </Col>
          <Col>
            <Button
              onClick={() => {
                updateStatus();
              }}
            >
              입금처리
            </Button>
          </Col>
          <Col className="col-2">
            <Form.Control
              as="select"
              onChange={(e) => {
                let size = e.target.value;
                setInfo({ ...info, size: size });
              }}
            >
              <option value="10">10줄</option>
              <option value="20">20줄</option>
              <option value="30">30줄</option>
              <option value="40">40줄</option>
              <option value="50">50줄</option>
            </Form.Control>
          </Col>
        </Row>
      </Form>
      <h5 className="mt-3">검색 결과</h5>
      <Table bordered style={{ textAlign: "center" }}>
        <thead style={styles}>
          <tr className="bg-custom-color">
            <th width="5%">
              <Form.Check aria-label="option 1" />
            </th>
            <th width="5%">no</th>
            <th>결제상태</th>
            <th>접수번호</th>
            <th width="10%">접수자명</th>
            <th>단체명</th>
            <th width="11%">전화번호</th>
            <th>접수일자</th>
            <th>결제방법</th>
            <th>입금자명</th>
            <th>참가비</th>
            <th>입금액</th>
            <th>종목수</th>
          </tr>
        </thead>
        <tbody>
          {result.map((joiner, key) => {
            return (
              <tr>
                <td>
                  <Form.Check
                    aria-label="option 1"
                    onChange={(e) => {
                      if (checkedList.length == 0) {
                        console.log("checkedList 비어있음 : ", joiner.joinSeq);
                        setCheckedList([joiner.joinSeq]);
                      } else {
                        let flag = false;
                        console.log(typeof checkedList);
                        checkedList.forEach((e) => {
                          if (e == joiner.joinSeq) {
                            flag = true;
                            console.log("이미 값이 있음");
                          }
                        });
                        if (flag) {
                          let tmpArray = checkedList.filter(
                            (element) => element !== joiner.joinSeq
                          );
                          console.log(
                            "중복된 값을 제외합니다. ",
                            tmpArray,
                            typeof checkedList
                          );
                          setCheckedList(tmpArray);
                        } else {
                          console.log("중복된 값이 없습니다. ", [
                            ...checkedList,
                            joiner.joinSeq,
                          ]);
                          setCheckedList([...checkedList, joiner.joinSeq]);
                        }
                      }
                    }}
                  />
                </td>
                <td>{key + 1}</td>
                <td>
                  {joiner.paymentStatus == "RSVT"
                    ? "입금대기"
                    : joiner.paymentStatus == "CMPL"
                      ? "입금완료"
                      : "참가취소"}
                </td>
                <td>{joiner.joinSeq}</td>
                <td>{joiner.joinerName}</td>
                <td>{joiner.exponent}</td>
                <td>{joiner.cellphone}</td>
                <td>{joiner.joinTime.substring(0, 10)}</td>
                <td>
                  {joiner.paymentType == "BANK" ? "계좌이체" : "카드결제"}
                </td>
                <td>{joiner.paymentType == "CARD" ? "-" : joiner.brief}</td>
                <td>{joiner.amount}</td>
                <td>{joiner.deposit}</td>
                <td>{joiner.ticketCount}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {isLoading ? (
        ""
      ) : (
        <PaginationCompAdminPayment
          pageMaxNo={pageInfo.pageMaxNo}
          active={pageInfo.pageNo}
          history={history}
          url="payment"
        />
      )}
    </Container>
  );
};
export default AdminPayment;
